import { Router } from '@angular/router';
import { HttpError } from '../../../models/errors/HttpError';
import { ssApiService } from '../../../services/ss-api.service';
import { ChangePasswordRequest } from '../../../models/ss-api/requests/change.password.request';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { xToastr, ToastrTypes } from '../../../shared/Toastr';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { GlobalServices } from 'app/services/global.service';

@Component({
    selector: 'account-change-password-new',
    templateUrl: './change-password-new.component.html',
    styleUrls: ['./change-password-new.component.scss']
})
export class ChangePasswordNewComponent implements OnInit {
	@Output() emitClose: EventEmitter<any> = new EventEmitter();
    Request = new ChangePasswordRequest();
    RepeatNewPassword: string = '';

    IsBusy: boolean = false;

    passwordForm: UntypedFormGroup;
	
	validationMessage : string = '';
	newPassword1BeingTyped: boolean = false;
	newPassword2BeingTyped: boolean = false;

    constructor(private api: ssApiService, private router: Router, private gb : GlobalServices) { }

    ngOnInit() {

		// this.gb.SetPageTitle("Change Password");

        this.passwordForm = new UntypedFormGroup({
            'password': new UntypedFormControl('', [Validators.required]),
            'newPassword1': new UntypedFormControl('', [Validators.required, Validators.minLength(6)]),
            'newPassword2': new UntypedFormControl('', [Validators.required, Validators.minLength(6)])
		});

		this.passwordForm.get('newPassword1').valueChanges.subscribe(val => {
			this.newPassword1BeingTyped = true;
		});

		this.passwordForm.get('newPassword2').valueChanges.subscribe(val => {
			this.newPassword2BeingTyped = true;
		});
		
		this.passwordForm.valueChanges.subscribe(val => {
			this.IsValidCheck();	
		});

    }

    ValidateNewPassword(): boolean {

        if ( !this.PasswordsMatch() ) {
            xToastr.ShowToast(ToastrTypes.Error, 'Validation Error', 'The new password and confirm password must match.');
            return false;
        }

        if ( !this.passwordForm.valid ) {
            xToastr.ShowToast(ToastrTypes.Error, 'Validation Error', 'Please make sure you entered valid passwords.');
            return false;
        }

        return true;
    }

    ChangePassword() {

        if (!this.ValidateNewPassword())
            return;



        this.IsBusy = true;

		let request = new ChangePasswordRequest();
		request.CurrentPassword = this.passwordForm.get('password').value;
		request.NewPassword = this.passwordForm.get('newPassword1').value;

		request.ValidationMessage = '';

        let disposable = this.api.ChangePassword( request )
            .subscribe(response => {
                disposable.unsubscribe();

                this.IsBusy = false;

                if (!response.Result) {
                    xToastr.ShowToast(ToastrTypes.Error, 'Error', response.Data);
                    return; // error
                }

                xToastr.ShowToast(ToastrTypes.Info, 'OK', 'Password changed');
				this.emitClose.emit();
                this.router.navigate(['authentication']);

            },


                (error: HttpError) => {
                    disposable.unsubscribe();
                    this.IsBusy = false;
                });

	}
	
	IsValidCheck() {
		if( this.passwordForm.get('password').value == '' )
			this.validationMessage = 'Please enter your current password';
		else if( this.passwordForm.get('newPassword1').value.length < 6 && this.newPassword1BeingTyped ) {
			this.validationMessage = 'Password must be at least 6 characters in length';
		}
		else if( !this.PasswordsMatch() && this.newPassword2BeingTyped ) {
			this.validationMessage = 'Please make sure your new passwords match'
		}
		else 
			this.validationMessage = '';
	}

	public PasswordsMatch() : boolean {
		
		let match = false;

		if( this.passwordForm == null ) {
			match = false;
		} else {
			if( this.passwordForm.get('newPassword1').value.length < 6 ) {
				match = false;
			} else {
				match = this.passwordForm.get('newPassword1').value == this.passwordForm.get('newPassword2').value;
			}
			
		}

		return match;
		
	}


	FeildsAreDirty() : boolean {

		let isDirty = false;

		if( this.passwordForm.get('newPassword1').dirty && this.passwordForm.get('newPassword2').dirty )
			isDirty = true;

		return isDirty;

	}

	ShowValidationIssue() : boolean {

		let hasIssue = false;

		if( this.FeildsAreDirty() ) {

			if( !this.passwordForm.valid )
				hasIssue = true;
		}

		return hasIssue;


	}


}
